<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow pb-5 elevation-8">
          <v-card-title primary-title>
            <div class="text-h5">Impostazioni Stripe</div>
            <v-spacer></v-spacer>
            <v-div>
              <!--            
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItem()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
            </v-div>           
          </v-card-title>
          <div 
            ref="scrollContainer"
            class="scroll-container"
            :max-height="wHeight-200"
          >
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else >

              <!-- ── Stripe Disconnect Confirm Dialog ───────────────────── -->
              <v-dialog v-model="dialog_disconnect" max-width="420" persistent>
                <v-card>
                  <v-card-title class="error white--text">
                    <v-icon left color="white">mdi-link-off</v-icon>
                    Scollega account Stripe
                  </v-card-title>
                  <v-card-text class="pt-4 text-body-1">
                    Sei sicuro di voler scollegare l'account Stripe? I pagamenti futuri non potranno più essere trasferiti automaticamente.
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn outlined color="grey" @click="dialog_disconnect = false">Annulla</v-btn>
                    <v-btn color="error" :loading="connectLoading" @click="confirmDisconnect">Scollega</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- ──────────────────────────────────────────────────────── -->

              <!-- ── Stripe Connect Result Dialog ───────────────────────── -->
              <v-dialog v-model="dialog_connect" max-width="480" persistent>
                <v-card>
                  <v-card-title :class="connectMessageType === 'success' ? 'success white--text' : 'error white--text'">
                    <v-icon left color="white">{{ connectMessageType === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
                    {{ connectMessageType === 'success' ? 'Stripe Connect' : 'Errore Stripe Connect' }}
                  </v-card-title>
                  <v-card-text class="pt-4 text-body-1">
                    {{ connectMessage }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="closeConnectDialog">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- ──────────────────────────────────────────────────────── -->

              <!-- ── Two-column layout ──────────────────────────────────── -->
              <v-row class="mx-2 mt-2" no-gutters>

                <!-- LEFT column ~27% — area = User -->
                <v-col cols="12" md="5" class="pr-2">
                  <v-card
                    v-for="group in userGroups"
                    :key="group.class"
                    class="neu-glow mb-4"
                  >
                    <v-card-title class="text-subtitle-1 font-weight-bold blue-grey darken-1 white--text py-2 px-3">
                      {{ group.class }}
                    </v-card-title>
                    <v-card-text class="pa-2">
                      <v-row
                        class="mx-1 py-1"
                        v-for="(i, ii) in group.items"
                        :key="ii"
                        align="center"
                      >
                        <!-- nvarchar: full-width text field -->
                        <template v-if="i.inputType === 'text'">
                          <v-col cols="11" class="py-2">
                            <v-text-field
                              counter
                              :label="i.description"
                              outlined
                              :name="i.optionId"
                              @input.native="save"
                              v-model="i.value"
                              persistent-placeholder
                              hide-details
                              dense
                              :readonly="!i.editableByUser"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="1">
                              <template v-if="i.help || !i.editableByUser" v-slot:append>
                                <v-tooltip max-width="250" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                                  </template>
                                  <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                                </v-tooltip>
                              </template>                        
                          </v-col>
                        </template>
                        <!-- switch : label + switch -->
                        <template v-else-if="i.inputType === 'switch'">
                          <v-col cols="8" class="py-3 text-body-2">{{ i.description }}</v-col>
                          <v-col cols="3" class="py-3">
                            <v-switch
                              color="info"
                              v-model="i.value"
                              inset
                              dense
                              @change="save2($event, i.optionId)"
                              :label="i.value ? 'Si' : 'No'"
                              hide-details
                              :readonly="!i.editableByUser"
                              class="mt-0 pt-0"
                            />
                          </v-col>
                          <v-col cols="1" class="py-3">
                            <v-tooltip max-width="250" top v-if="i.help || !i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                            </v-tooltip>
                          </v-col>
                        </template>
                        <!-- select / multiselect -->
                        <template v-else-if="i.inputType === 'select' || i.inputType === 'multiselect'">
                          <v-col cols="8" class="py-1 text-body-2">{{ i.description }}</v-col>
                          <v-col cols="3" class="py-1">
                            <v-select
                              v-model="i.value"
                              :items="i.acceptedValues ? i.acceptedValues.split(',').map(v => v.trim()) : []"
                              :multiple="i.inputType === 'multiselect'"
                              :chips="i.inputType === 'multiselect'"
                              :small-chips="i.inputType === 'multiselect'"
                              outlined
                              dense
                              hide-details
                              :readonly="!i.editableByUser"
                              :name="i.optionId"
                              @change="save2($event, i.optionId)"
                            />
                          </v-col>
                          <v-col cols="1" class="py-1">
                            <v-tooltip max-width="250" top v-if="i.help || !i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                            </v-tooltip>
                          </v-col>
                        </template>
                        <!-- other numeric types -->
                        <template v-else>
                          <v-col cols="8" class="py-1 text-body-2">{{ i.description }}</v-col>
                          <v-col cols="3" class="py-1">
                            <v-text-field
                              counter
                              @input.native="save"
                              label=""
                              outlined
                              :name="i.optionId"
                              reverse
                              dense
                              type="number"
                              v-model.number="i.value"
                              persistent-placeholder
                              hide-details
                              :readonly="!i.editableByUser"
                            />
                          </v-col>
                          <v-col cols="1" class="py-1">
                            <v-tooltip max-width="250" top v-if="i.help || !i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                            </v-tooltip>
                          </v-col>
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- RIGHT column ~73% — Stripe Connect + area = Keys / KeysTest -->
                <v-col cols="12" md="7" class="pl-2">

                  <!-- ── Stripe Connect Status Card ───────────────────── -->
                  <v-card class="neu-glow mb-4">
                    <v-card-title class="text-subtitle-1 font-weight-bold blue-grey darken-1 white--text py-2 px-3">
                      <v-icon left color="white" small>mdi-link-variant</v-icon>
                      Stripe Connect
                    </v-card-title>
                    <v-card-text class="pa-3">
                      <!-- Connected -->
                      <div v-if="connectAccountId">
                        <div class="d-flex align-center flex-wrap mb-3">
                          <v-icon color="success" class="mr-1">mdi-check-circle</v-icon>
                          <span class="success--text font-weight-medium mr-3">Account collegato:</span>
                          <code class="text-h6 px-4 pa-1 rounded mr-3">{{ connectAccountId }}</code>
                          <v-btn outlined color="error" :loading="connectLoading" @click="disconnectStripe">
                            <v-icon left >mdi-link-off</v-icon>
                            Scollega
                          </v-btn>
                        </div>
                        <v-alert dense text type="success" class="mb-0 text-body-2">
                          Il tuo account Stripe è collegato correttamente. I pagamenti ricevuti verranno trasferiti su questo account.
                        </v-alert>
                      </div>
                      <!-- Not connected -->
                      <div v-else>
                        <div class="d-flex align-center flex-wrap mb-3">
                          <v-icon color="grey" class="mr-2">mdi-link-variant-off</v-icon>
                          <span class="grey--text mr-4">Nessun account Stripe collegato</span>
                          <v-btn color="primary" :loading="connectLoading" @click="initiateStripeConnect">
                            <v-icon left>mdi-link-variant</v-icon>
                            Connetti Stripe
                          </v-btn>
                        </div>
                        <!-- How-to hints -->
                        <v-alert dense text type="info" icon="mdi-information-outline" class="mb-2 text-body-2">
                          <strong>Come funziona il collegamento:</strong>
                          <ol class="mt-1 pl-4 mb-0">
                            <li>
                              <strong>Crea prima l'account Stripe</strong> su
                              <a href="https://stripe.com" target="_blank" rel="noopener">stripe.com</a>
                              — la verifica dell'identità e dei documenti bancari può richiedere
                              <strong>alcune ore o anche 1–2 giorni lavorativi</strong>.
                            </li>
                            <li class="mt-1">
                              Una volta che il tuo account Stripe è attivo e verificato, torna qui e clicca
                              <strong>Connetti Stripe</strong> — il collegamento avviene in pochi secondi.
                            </li>
                            <li class="mt-1">
                              Verrai reindirizzato su Stripe per autorizzare la connessione, poi tornerai automaticamente su questa pagina.
                            </li>
                          </ol>
                        </v-alert>
                        <v-alert dense text type="warning" icon="mdi-clock-alert-outline" class="mb-0 text-body-2">
                          Non cliccare <em>Connetti Stripe</em> prima che il tuo account Stripe sia completamente attivato: la connessione potrebbe non riuscire.
                        </v-alert>
                      </div>
                    </v-card-text>
                  </v-card>
                  <!-- ────────────────────────────────────────────────── -->

                  <!-- ── Webhook Sync Card ────────────────────────────── -->
                  <v-card class="neu-glow mb-4">
                    <v-card-title class="text-subtitle-1 font-weight-bold blue-grey darken-1 white--text py-2 px-3">
                      <v-icon left color="white" small>mdi-webhook</v-icon>
                      Sincronizzazione Pagamenti (Webhook)
                    </v-card-title>
                    <v-card-text class="pa-3">
                      <v-progress-linear v-if="webhookLoading" indeterminate color="info" class="mb-3" />

                      <!-- Registered -->
                      <div v-else-if="webhookStatus && webhookStatus.registered">
                        <div class="d-flex align-center flex-wrap mb-2">
                          <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                          <span class="success--text font-weight-medium mr-3">Webhook attivo</span>
                          <code class="text-h6 px-2 py-1 rounded mr-2">{{ webhookStatus.webhookId }}</code>
                          <v-chip small :color="webhookStatus.status === 'enabled' ? 'success' : 'warning'" outlined>
                            {{ webhookStatus.status }}
                          </v-chip>
                        </div>
                        <div class="text-caption grey--text mb-2">{{ webhookStatus.url }}</div>
                        <v-alert v-if="!webhookStatus.secretSaved" dense text type="warning" class="mb-2 text-body-2">
                          {{ webhookStatus.secretHint }}
                          <v-btn small color="warning" class="ml-2" :loading="webhookLoading" @click="registerWebhook(true)">
                            Rigenera Secret
                          </v-btn>
                        </v-alert>
                        <v-alert v-else dense text type="success" class="mb-0 text-body-2">
                          Sincronizzazione automatica attiva. Le modifiche fatte direttamente su Stripe (cattura, annullamento, rimborso) vengono aggiornate nel database automaticamente.
                        </v-alert>
                      </div>

                      <!-- Not registered -->
                      <div v-else-if="webhookStatus && !webhookStatus.registered">
                        <div class="d-flex align-center flex-wrap mb-3">
                          <v-icon color="orange" class="mr-2">mdi-alert-circle</v-icon>
                          <span class="orange--text mr-4">Webhook non registrato</span>
                          <v-btn color="info" :loading="webhookLoading" @click="registerWebhook(true)">
                            <v-icon left>mdi-webhook</v-icon>
                            Registra Webhook
                          </v-btn>
                        </div>
                        <v-alert dense text type="info" class="mb-0 text-body-2">
                          Senza webhook, le modifiche ai pagamenti fatte direttamente su Stripe non verranno sincronizzate nel database di iBook.
                          La registrazione avviene in <strong>automatico</strong> — non è necessario accedere al pannello Stripe.
                        </v-alert>
                      </div>

                      <!-- Not checked yet -->
                      <div v-else class="d-flex align-center">
                        <v-btn outlined color="info" :loading="webhookLoading" @click="registerWebhook(false)">
                          <v-icon left>mdi-magnify</v-icon>
                          Verifica stato webhook
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                  <!-- ────────────────────────────────────────────────── -->

                  <!-- Keys / KeysTest groups -->
                  <v-card
                    v-for="group in keysGroups"
                    :key="group.class"
                    class="neu-glow mb-4"
                  >
                    <v-card-title class="text-subtitle-1 font-weight-bold blue-grey darken-1 white--text py-2 px-3">
                      {{ group.class }}
                    </v-card-title>
                    <v-card-text class="pa-2">
                      <v-row
                        class="mx-1 py-1"
                        v-for="(i, ii) in group.items"
                        :key="ii"
                        align="center"
                      >
                        <!-- nvarchar: full-width text field -->
                        <v-col cols="12" v-if="i.inputType === 'text'" class="py-2">
                          <v-text-field
                            counter
                            :label="i.description"
                            outlined
                            dense
                            :name="i.optionId"
                            @input.native="save"
                            v-model="i.value"
                            persistent-placeholder
                            hide-details
                            :readonly="!i.editableByUser"
                          >
                            <template v-if="i.help || !i.editableByUser" v-slot:append>
                              <v-tooltip max-width="250" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                                </template>
                                <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <!-- bit: label + switch -->
                        <template v-else-if="i.inputType === 'switch'">
                          <v-col cols="5" class="py-1 text-body-2">{{ i.description }}</v-col>
                          <v-col cols="2" class="py-1">
                            <v-switch
                              color="info"
                              v-model="i.value"
                              inset
                              @change="save2($event, i.optionId)"
                              :label="i.value ? 'Si' : 'No'"
                              hide-details
                              :readonly="!i.editableByUser"
                              class="mt-0 pt-0"
                            />
                          </v-col>
                          <v-col cols="1" class="py-1">
                            <v-tooltip max-width="250" top v-if="i.help || !i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                            </v-tooltip>
                          </v-col>
                        </template>
                        <!-- other numeric types -->
                        <template v-else>
                          <v-col cols="8" class="py-1 text-body-2">{{ i.description }}</v-col>
                          <v-col cols="3" class="py-1">
                            <v-text-field
                              counter
                              @input.native="save"
                              label=""
                              outlined
                              :name="i.optionId"
                              reverse
                              v-model="i.value"
                              persistent-placeholder
                              hide-details
                              :readonly="!i.editableByUser"
                            />
                          </v-col>
                          <v-col cols="1" class="py-1">
                            <v-tooltip max-width="250" top v-if="i.help || !i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="info" small>mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser ? 'Sola Lettura' : i.help"></span>
                            </v-tooltip>
                          </v-col>
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>

                </v-col>
              </v-row>
              <!-- ──────────────────────────────────────────────────────── -->

            </div>
          </div>
        </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import { VueEditor  } from "vue2-editor";
import _ from 'lodash'
// mettere prima di data() =>components: { VueEditor },
//https://github.com/DerYeger/yeger/blob/main/docs/vue-masonry-wall-docs/src/app.vue
export default {
  
  data() {
    return {
      page: "Settings",
      dialog_edit:false,
      dialog_delete:false,
      dialog_instruction:false,
      loading:false,
      snackbar:false,
      snackbar_color:'success',
      snackbar_message:null,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      items_hash:null,
      items:[],
      editedItem:{name:"",sortOrder:null,icon:"",active:false},
      loading_refresh:false,
      // Stripe Connect
      connectAccountId: null,
      connectLoading: false,
      connectMessage: null,
      connectMessageType: 'success',
      dialog_connect: false,
      dialog_disconnect: false,
      // Webhook
      webhookStatus: null,
      webhookLoading: false,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Descrizione',       value: 'description',  align: 'left',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Parametro',         value: 'parameter',    align: 'left',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Impostazione',      value: 'dataType',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Azione',      value: 'actions',                         sortable: false, class:'pl-1 text-lg-button' },
                /*,
                { text: 'ID',           value: 'optionId',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Tipo',         value: 'dataType',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Icona WA',     value: 'waIcon',        align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Attiva',       value: 'active',        align: 'center',  sortable: false, class:'px-1 text-lg-button' },*/
              ],      
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ],      
     
    };
  },
  computed : {
    ...mapGetters(["settings"]),

    /**
     * Groups for the LEFT narrow column — area = 'User'
     * Returns [{ class, area, items[] }] sorted by classSortOrder asc
     */
    userGroups() {
      return this._buildGroups(['User'])
    },

    /**
     * Groups for the RIGHT wide column — area = 'Keys' or 'KeysTest'
     * Returns [{ class, area, items[] }] sorted by classSortOrder asc
     */
    keysGroups() {
      return this._buildGroups(['Keys', 'KeysTest'])
    },
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    // Handle Stripe Connect OAuth callback — result comes via URL params (from PHP redirect)
    // Save to sessionStorage so it survives component remounts, then clean the URL immediately
    const q = this.$route ? this.$route.query : {}

    if (q.connect_success) {
      // Store result in sessionStorage
      sessionStorage.setItem('stripe_connect_result', JSON.stringify({
        type: 'success',
        message: 'Account Stripe collegato con successo!',
        acct: q.acct || null
      }))
      // Clean URL params immediately
      this.$router.replace({ path: this.$route.path, query: { pageId: 'stripe' } }).catch(() => {})
    } else if (q.connect_error) {
      sessionStorage.setItem('stripe_connect_result', JSON.stringify({
        type: 'error',
        message: 'Errore collegamento Stripe: ' + decodeURIComponent(q.connect_error)
      }))
      this.$router.replace({ path: this.$route.path, query: { pageId: 'stripe' } }).catch(() => {})
    }

    // Read pending result from sessionStorage and show dialog
    const pendingResult = sessionStorage.getItem('stripe_connect_result')
    if (pendingResult) {
      try {
        const result = JSON.parse(pendingResult)
        this.connectMessage     = result.message
        this.connectMessageType = result.type
        if (result.type === 'success' && result.acct) {
          this.connectAccountId = result.acct
        }
        this.dialog_connect = true
        // Do NOT delete here — delete only when user closes the dialog (closeConnectDialog)
      } catch (e) {
        sessionStorage.removeItem('stripe_connect_result')
      }
    }
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
  },
  methods:
  {
    /**
     * Build grouped arrays filtered by area, sorted by classSortOrder then sortOrder
     */
    _buildGroups(areas) {
      const filtered = this.items.filter(i => areas.includes(i.area))
      // collect unique classes preserving classSortOrder order
      const classMap = new Map()
      filtered.forEach(i => {
        if (!classMap.has(i.class)) {
          classMap.set(i.class, { class: i.class, area: i.area, classSortOrder: i.classSortOrder, items: [] })
        }
        classMap.get(i.class).items.push(i)
      })
      return Array.from(classMap.values())
        .sort((a, b) => (a.classSortOrder ?? 999) - (b.classSortOrder ?? 999))
    },

    save: _.debounce(function (event) {
      console.log(400,event.target.name,event.target.value)
      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var pload={"optionId":event.target.name,"value":value};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field) {
      console.log(410,value, field);
      // multiselect returns array — join back to comma-separated string for DB
      let normalized = Array.isArray(value) ? value.join(',') : value
      normalized = normalized === false ? 0 : normalized === true ? 1 : normalized === '' ? null : normalized
      var pload = { optionId: field, value: normalized };
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },     
    editItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem()
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var options=this.items.map(({ optionId, value }) => ({ optionId, value:value===false?0:value===true?1:value===''?null:value }));
        var action='saveItem';
        let payload={"action":action,"table":"AllOptions","payload":JSON.stringify(options)}
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;

        }   
    },

    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"Stripe_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0': {
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.map(o=>{
                    if (o.dataType == 'bit') {
                      o.value = o.value === '1' ? true : (o.value === '0' ? false : o.value)
                    } else if (o.inputType === 'multiselect' && o.value) {
                      // stored as comma-separated string, v-select multiple needs array
                      o.value = o.value.split(',').map(v => v.trim()).filter(v => v)
                    }
                    return o
                  });
                    this.items_hash=JSON.stringify(this.items);
                    // Populate connect account id from loaded settings
                    const connectItem = this.items.find(i => i.optionId === 'stripeConnectAccountId')
                    if (connectItem) this.connectAccountId = connectItem.value || null
                    //this.items==Object.entries(settings).map(([key, value]) => ({key,value}));
                    console.log(315,this.items,res.data.payloads)
                    break;
                }
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    /**
     * Close the Stripe Connect result dialog and clear the stored result
     */
    closeConnectDialog() {
      this.dialog_connect = false
      this.connectMessage = null
      sessionStorage.removeItem('stripe_connect_result')
    },
    /**
     * Initiate Stripe Connect OAuth — redirects browser to Stripe
     */
    async initiateStripeConnect() {
      this.connectLoading  = true
      this.connectMessage  = null
      try {
        const res = await this.$http.post('/stripe/stripe-connect-initiate.php', JSON.stringify({
          action: 'initiateConnect',
          csrf: sessionStorage.getItem('csrf'),
          payload: {}
        }))
        if (res.data.errorid === '0') {
          // Redirect the whole page to Stripe's hosted OAuth screen
          window.location.href = res.data.payloads.url
        } else {
          this.connectMessage     = res.data.message || 'Errore avvio collegamento Stripe'
          this.connectMessageType = 'error'
          this.connectLoading     = false
        }
      } catch (e) {
        this.connectMessage     = 'Errore di connessione'
        this.connectMessageType = 'error'
        this.connectLoading     = false
      }
    },

    /**
     * Check or register the platform Connect webhook.
     * register=false → check only
     * register=true  → create if not present
     */
    async registerWebhook(register) {
      this.webhookLoading = true
      try {
        const res = await this.$http.post('/stripe/register-connect-webhook.php', JSON.stringify({
          csrf: sessionStorage.getItem('csrf'),
          payload: { register: !!register }
        }))
        if (res.data.errorid === '0') {
          this.webhookStatus = res.data.payloads
        } else {
          this.snackbar_color   = 'error'
          this.snackbar_message = res.data.message || 'Errore webhook'
          this.snackbar         = true
        }
      } catch (e) {
        this.snackbar_color   = 'error'
        this.snackbar_message = 'Errore di connessione'
        this.snackbar         = true
      } finally {
        this.webhookLoading = false
      }
    },

    /**
     * Disconnect Stripe Connect — shows confirmation dialog first
     */
    disconnectStripe() {
      this.dialog_disconnect = true
    },

    /**
     * Confirmed disconnect — clears acct_xxx from settings
     */
    async confirmDisconnect() {
      this.dialog_disconnect = false
      this.connectLoading = true
      this.connectMessage = null
      const pload = { optionId: 'stripeConnectAccountId', value: null }
      const w = await this.updateDB({ action: 'saveItem', table: 'User_Options', payload: pload })
      this.connectLoading = false
      if (w && w.errorid === '0') {
        this.connectAccountId   = null
        this.connectMessage     = 'Account Stripe scollegato.'
        this.connectMessageType = 'info'
        this.dialog_connect     = true
      } else {
        this.connectMessage     = 'Errore durante la disconnessione'
        this.connectMessageType = 'error'
        this.dialog_connect     = true
      }
    },

    async updateDB(payload){        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style scoped>
.scroll-container {
  overflow-y: auto;
}
</style>